import dates from "tools/dates";
import proxy from "api/proxy";

async function getAvailableRooms(arrival, departure, accoId) {
  let arrivalDate = arrival;
  let departureDate = departure;
  if (typeof departure !== "string") {
    departureDate = dates.fmtDate2Tryton(departure);
  }
  if (typeof arrival !== "string") {
    arrivalDate = dates.fmtDate2Tryton(arrival);
  }

  const { data } = await proxy.methodCall({
    model: "hotel.room",
    method: "available_for_web",
    args: [arrivalDate, departureDate, null],
    kwargs: {},
  });
  const res = data.records.find((item) => item.id === accoId);
  if (res) return res.rooms;
}

async function searchAvailableRooms(record, parentRec) {
  const departureDate = record?.departure_date || parentRec?.departure_date;
  const arrivalDate = record?.arrival_date || parentRec?.arrival_date;
  const accoId = record?.product?.id || parentRec?.product.id;

  let domain;
  if (record?.overbooking) {
    domain = ["accommodation", "=", accoId];
  } else {
    const roomsAvailable = await getAvailableRooms(
      arrivalDate,
      departureDate,
      accoId,
    );
    if (roomsAvailable) {
      domain = [
        ["accommodation", "=", accoId],
        ["id", "in", roomsAvailable],
      ];
    }
  }
  return domain;
}

function layout(props) {
  const editCheckIn = props?.registration_state === "check_in";
  const ctxView = {
    model: "hotel.folio.update",
    form_action: [],
    table_action: [],
    fields: {
      arrival_date: {
        type: "date",
        readOnly: editCheckIn,
      },
      departure_date: {
        type: "date",
      },
      overbooking: {
        type: "boolean",
        translate: true,
      },
      unit_price: {
        type: "numeric",
      },
      room: {
        type: "many2one",
        model: "hotel.room",
        recSearch: searchAvailableRooms,
      },
      product: {
        type: "many2one",
        model: "product.product",
        recSearch: () => ["department", "=", "accommodation"],
      },
    },
    list: [],
    form: [
      { name: "arrival_date" },
      { name: "departure_date" },
      { name: "unit_price" },
      { name: "overbooking" },
      { name: "product" },
      { name: "room" },
    ],
  };

  return ctxView;
}

export { layout };
